import { Identifier } from "../common/Identifier";
import {Nameable} from "../common/Nameable";
import {SoftDeletable} from "../common/SoftDeletable";
import {Module} from "../common/Module";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {isPrivileged} from "../../config/Privileges";
import {CONTRACTOR_AREA_NAME} from "./Contractor";
import {ExternalWork} from "./ExternalWork";
import {OptionType} from "../../components/form/SearchableSelect";
import {ExternalWorkArea} from "./ExternalWorkArea";

/**
 * Module for external work group
 */
export const ExternalWorkGroupModule: Module = {
    identifier: "external_work_group",
    isPrivileged: (authUser: AuthenticatedUser | null, privilege: string) => isPrivileged(
        authUser,
        CONTRACTOR_AREA_NAME,
        ExternalWorkGroupModule.identifier,
        privilege
    )
};

export interface ExternalWorkGroupId {
    externalWorkGroupId: Identifier< number >
}

/**
 * ExternalWorkGroup allows grouping of individual external work items under one common descriptor
 */
export interface ExternalWorkGroup extends Nameable, ExternalWorkGroupId, SoftDeletable {
    shorthand: string
    area: ExternalWorkArea
    numberOfPhases: number
    phasesPerTask: ExternalWorkGroupPhasesPerTask[]
}

export interface ExternalWorkGroupSelectOption extends OptionType {
    shorthand: string
    numPhases: number
    phasesPerTask: ExternalWorkGroupPhasesPerTask[]
}

export type ExternalWorkGroupProp = { externalWorkGroup: ExternalWorkGroup }

export interface ExternalWorkGroupRequest extends Nameable {
    externalWorkGroupId: number
    shorthand: string
    externalWork: ExternalWork[]
    externalWorkAreaId: number
    numberOfPhases: number
    numPhasesPerTask: ExternalWorkGroupPhasesPerTask[]
}

export interface ExternalWorkGroupPhasesPerTask {
    id: Identifier<number>
    name: string
    numberOfPhases: number
}

export type ExternalWorkGroupRequestProp = {
    externalWorkGroup: ExternalWorkGroupRequest
}

/**
 * external work group select api route
 */
export const EXTERNAL_WORK_GROUP_SELECT_ROUTE = `external-work/groups/select`;